import { editZoneTypes, editZoneReturnTypes } from 'constants/scripts';
import { drawingStates } from 'constants/values';
import {
  calcZonesForAddPivot,
  calcZonesForAddPolygon,
  calcZonesForAddSquare,
  calcZonesForMerge,
  calcZonesForSplit
} from 'util/zoneDrawing';

export function workerLogError(e) {
  const error = {
    ...e,
    error: parseError(e.error)
  };
  self.postMessage({
    type: editZoneReturnTypes.LOG_ERROR,
    error: JSON.stringify(error)
  });
}

export function workerLog(message) {
  self.postMessage({
    type: editZoneReturnTypes.LOG,
    message: JSON.stringify(message)
  });
}

function parseError(error) {
  if (error instanceof Error) {
    return Object.getOwnPropertyNames(error).reduce((result, key) => ({
      ...result,
      [key]: error[key]
    }), {});
  }
  return error;
}

self.onmessage = e => {
  // https://github.com/facebook/react-devtools/issues/812
  if ((/^react-devtools/gi).test(e.data.source)
     || (/^@devtools-page/gi).test(e.data.source)) {
    return;
  }

  switch(e.data.type) {
    case editZoneTypes.MERGE: {
      const { mergeZoneIds, scriptType, zones } = e.data;
      const newZones = calcZonesForMerge({ mergeZoneIds, scriptType, zones });
      self.postMessage({ newZones });
      break;
    }
    case editZoneTypes.SPLIT: {
      const { splitZoneId, zones, flags } = e.data;
      const newZones = calcZonesForSplit({ splitZoneId, zones, flags });
      self.postMessage({ newZones });
      break;
    }
    case editZoneTypes.ADD_ZONE: {
      const { actions, boundaries, drawingState, newZoneGeoJson, scriptType, zones, isCheckStrip } = e.data;
      let actionType, calcFunction;

      switch (drawingState) {
        case drawingStates.DRAWING_PIVOT:
          actionType = actions.ADD_PIVOT_ZONE;
          calcFunction = calcZonesForAddPivot;
          break;
        case drawingStates.DRAWING_SQUARE:
          actionType = actions.ADD_SQUARE_ZONE;
          calcFunction = calcZonesForAddSquare;
          break;
        case drawingStates.DRAWING_POLYGON:
          actionType = actions.ADD_POLYGON_ZONE;
          calcFunction = calcZonesForAddPolygon;
          break;
        default:
          workerLogError({ message: `Unexpected drawingState - ${drawingState}.` });
      }

      if (calcFunction) {
        const newZones = calcFunction({ boundaries, newZoneGeoJson, scriptType, zones, isCheckStrip });
        self.postMessage({ newZones, actionType });
      }
      break;
    }
    default: {
      break;
    }
  }
};

self.addEventListener('error', (e) => {
  workerLogError(e);
});
